export const chineseContent = {
  helpCenter: "帮助中心",
  placeholder: "请输入关键字",
  helpDocument: "帮助文档",
  catalogueTitle: "文章目录",
  dashboard: {
    title: "请问有什么可以帮助你?",
    recommend: "内容推荐",
    more: "更多",
  },
  navbar: { language: "简体中文", login: "登录" },
  articleDetail: {
    pagenation: { next: "下一篇", prev: "上一篇" },
    hasHelp: {
      title: "此文章对你是否有帮助?",
      options: ["是", "否"],
      paramMap: { 是: 0, 否: 1 },
    },
  },
}

export const englishContent = {
  helpCenter: "Help Center",
  placeholder: "Please enter keywords",
  helpDocument: "Help documentation",
  catalogueTitle: "Article Catalogue",
  dashboard: {
    title: "What can I help you with?",
    recommend: "Content recommendation",
    more: "More",
  },
  navbar: { language: "English", login: "Login" },
  articleDetail: {
    pagenation: { next: "Next article", prev: "Previous article" },
    hasHelp: {
      title: "Is this article helpful to you?",
      options: ["Yes", "No"],
      paramMap: { Yes: 0, No: 1 },
    },
  },
}

export const languageMap = {
  zh: {
    id: 63, // 侧边栏菜单接口需要的参数
    text: chineseContent
  },
  en: {
    id: 74,
    text: englishContent,
  },
}
